import { render, staticRenderFns } from "./FormularioConfigBasica.vue?vue&type=template&id=47eeb2fe&scoped=true"
import script from "./FormularioConfigBasica.vue?vue&type=script&lang=js"
export * from "./FormularioConfigBasica.vue?vue&type=script&lang=js"
import style0 from "./FormularioConfigBasica.vue?vue&type=style&index=0&id=47eeb2fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eeb2fe",
  null
  
)

export default component.exports